import {
  GET_CURRANCIES_REQUEST,
  GET_CURRANCIES_RESPONSE,
  GET_BRANCHES_LOOKUP_REQUEST,
  GET_BRANCHES_LOOKUP_RESPONSE,
  GET_PROVIDERS_LOOKUP_REQUEST,
  GET_PROVIDERS_LOOKUP_RESPONSE,
  GET_SERVICES_LOOKUP_REQUEST,
  GET_SERVICES_LOOKUP_RESPONSE,
  GET_SPECIALITIES_LOOKUP_REQUEST,
  GET_SPECIALITIES_LOOKUP_REASPONSE
} from './types';

// list
export const getCurranciesRequest = (payload) => ({
  type: GET_CURRANCIES_REQUEST,
  payload,
});
export const getCurranciesResponse = (payload) => ({
  type: GET_CURRANCIES_RESPONSE,
  payload,
});

export const getSpecialtiesLookupRequest = (payload) => ({
  type: GET_SPECIALITIES_LOOKUP_REQUEST,
  payload,
});
export const getSpecialtiesLookupResponse = (payload) => ({
  type: GET_SPECIALITIES_LOOKUP_REASPONSE,
  payload,
});

export const getBranchesLookupRequest = (payload) => ({
  type: GET_BRANCHES_LOOKUP_REQUEST,
  payload,
});
export const getBranchesLookupResponse = (payload) => ({
  type: GET_BRANCHES_LOOKUP_RESPONSE,
  payload,
});

export const getProvidersLookupRequest = (payload) => ({
  type: GET_PROVIDERS_LOOKUP_REQUEST,
  payload,
});
export const getProvidersLookupResponse = (payload) => ({
  type: GET_PROVIDERS_LOOKUP_RESPONSE,
  payload,
});

export const getServicesLookUpRequest = (payload) => ({
  type: GET_SERVICES_LOOKUP_REQUEST,
  payload,
});
export const getServicesLookUpResponse = (payload) => ({
  type: GET_SERVICES_LOOKUP_RESPONSE,
  payload,
});
